"use client";
import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation";
import deviceInfo from "../utils/deviceInfo";
import tohash from "../utils/tohash";
import { useAuthStore } from "../store/authstore";
import { useLoggedOutDialogStore } from "../store/LoggedOutDialogState";

async function checkStatusAPI(deviceid: string, userid: string) {
    try {
        if (!deviceid || !userid) return 1;
        const res = await fetch("https://dramasstory.com/web/user_login_status.php", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ device_id: deviceid, user_id: userid }),
        })
        const data = await res.json();

        // console.log('login Status: ',data.data.Data)
        return data.data.Data;
    } catch (error) {
        console.error("Error checking status:", error);
        return 1; // Default to logged in if there's an error
    }
}

export default function StatusChecker() {
    const pathname = usePathname();
    const { openDialog, closeDialog } = useLoggedOutDialogStore((s) => s);
    const firstLoad = useRef(true);
    const user = useAuthStore((s) => s.user);
    const login = useAuthStore((s) => s.login);
    const device = deviceInfo()
    const deviceId = tohash(`${device.name}${device.platform}${device.os}${user?.user_email}${device.version}`)


    useEffect(() => {
        if (firstLoad.current) {
            firstLoad.current = false;
        } else {
            checkStatusAPI(deviceId || "", user?.user_id || "").then(e => {
                if (e.login_status === "0") {
                    openDialog()
                } else {
                    if (pathname !== "/login" && pathname !== "/signup" && user) {
                        login({...user,...e})
                        // console.log({...user,...e})
                        closeDialog();
                    }
                }
            }).catch(() => {
                closeDialog();
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname, deviceId, user?.user_id, openDialog, closeDialog]);

    useEffect(() => {
        checkStatusAPI(deviceId || "", user?.user_id || "").then(e => {
            if (e.login_status === "0") {
                openDialog();
            } else {
                closeDialog();
            }
        }).catch(() => {
            closeDialog();
        });
    }, [user, deviceId, openDialog, closeDialog]);

    return null;
}